import config from "../config";
import handleResponse from "./helper";


export const storageAdminService = {
    getPrimaries,
    addPrimary,
    updatePrimary,
    deletePrimary,
    getLevel2ForPrimary,
    addLevel2ForPrimary,
    updateLevel2ForPrimary,
    deleteLevel2ForPrimary,
    isUserInAdminGroup,
    getLevel2ForApplication
}

function getPrimaries(token, application_id) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/storage/get-primary-for-application/${application_id}`, requestOptions).then(handleResponse);

}
function getLevel2ForApplication(token, applicaiton_id) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/storage/admin-application-level2/?application_id=${applicaiton_id}`, requestOptions).then(handleResponse);

}

function getLevel2ForPrimary(token, primary_id) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/storage/get-level2-for-primary/${primary_id}`, requestOptions).then(handleResponse);

}

function addPrimary(token, data) {
    const requestOptions = {
        method: 'POST',
        headers: { Authorization: "Bearer " + token },
        body: data
    }
    return fetch(`${config.apiUrl}/storage/admin-application-primary/`, requestOptions).then(handleResponse);
}
function updatePrimary(token, id, data) {
    const requestOptions = {
        method: "PUT",
        headers: { Authorization: "Bearer " + token },
        body: data,
    }
    return fetch(`${config.apiUrl}/storage/admin-application-primary/` + id, requestOptions).then(handleResponse);
}
function deletePrimary(token, id) {
    const requestOptions = {
        method: 'DELETE',
        headers: { Authorization: "Bearer " + token },
    }
    return fetch(`${config.apiUrl}/storage/admin-application-primary/` + id, requestOptions).then(handleResponse);
}

function addLevel2ForPrimary(token, data) {
    const requestOptions = {
        method: 'POST',
        headers: { Authorization: "Bearer " + token },
        body: data
    }
    return fetch(`${config.apiUrl}/storage/admin-application-level2/`, requestOptions).then(handleResponse);
}

function updateLevel2ForPrimary(token, id, data) {
    const requestOptions = {
        method: "PUT",
        headers: { Authorization: "Bearer " + token },
        body: data,
    }
    return fetch(`${config.apiUrl}/storage/admin-application-level2/` + id, requestOptions).then(handleResponse);
}
function deleteLevel2ForPrimary(token, id) {
    const requestOptions = {
        method: 'DELETE',
        headers: { Authorization: "Bearer " + token },
    }
    return fetch(`${config.apiUrl}/storage/admin-application-level2/` + id, requestOptions).then(handleResponse);
}

function isUserInAdminGroup(token, application_id) {
    const requestOptions = {
        method: "GET",
        headers: { Authorization: "Bearer " + token },
    };
    return fetch(`${config.apiUrl}/storage/admin-check-in/${application_id}`, requestOptions).then(handleResponse);
}

